import { render } from "./client-create.vue?vue&type=template&id=f04285f8&scoped=true"
import script from "./client-create.vue?vue&type=script&lang=js"
export * from "./client-create.vue?vue&type=script&lang=js"

import "./client-create.vue?vue&type=style&index=0&id=f04285f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04285f8"]])

export default __exports__